import {
  BasicInformationSectionV2,
  BiographySectionV2,
  CaresAboutSectionV2,
  ChannelsSectionV2,
  DemographicsSectionV2,
  GainsSectionV2,
  GwiLinkSectionV2,
  PainsSectionV2,
} from '../sectionsV2';

export function PersonaInformationTabV2() {
  return (
    <div className="flex flex-col gap-xl">
      <BasicInformationSectionV2 />
      <BiographySectionV2 />
      <DemographicsSectionV2 />
      <CaresAboutSectionV2 />
      <ChannelsSectionV2 />
      <PainsSectionV2 />
      <GainsSectionV2 />
      <GwiLinkSectionV2 />
    </div>
  );
}

PersonaInformationTabV2.displayName = 'PersonaInformationTabV2';
